import { format } from "date-fns";

export interface PoListDateFilters {
  startDate: Date | null;
  endDate: Date | null;
}

export interface PoListRequestFilters {
  status?: string;
  startDate?: string;
  endDate?: string;
}

export function buildPoListFilters(
  statusValue: string,
  dateFilters: PoListDateFilters,
): PoListRequestFilters {
  const filters: PoListRequestFilters = {};
  if (statusValue) filters.status = statusValue;
  if (dateFilters.startDate && dateFilters.endDate) {
    filters.startDate = format(dateFilters.startDate, "yyyy-MM-dd");
    filters.endDate = format(dateFilters.endDate, "yyyy-MM-dd");
  }
  return filters;
}
